// src/routes/UserRoutes.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserLayout from '../components/layout/UserLayout'; // El marco
import RestriccionMorosidadGuard from '../components/RestriccionMorosidadGuard';
import ModuloGuard from '../components/ModuloGuard';
//Contenido
// UserDashboard intentionally not imported for resident role to avoid exposing admin dashboard
import Configuraciones from '../pages/Configuraciones';
import ConfiguracionRecibos from '../pages/ConfiguracionRecibos';
import PreguntasFrecuentes from '../pages/PreguntasFrecuentes';
import Soporte from '../pages/Soporte';
import Perfil from '../pages/Perfil';
import Comunidad from '../pages/Comunidad';
import Amenidades from '../pages/Amenidades';
import Vigilancia from '../pages/Vigilancia';
import Finanzas from '../pages/Finanzas';
import FinanzasUsuario from '../pages/FinanzasUsuario';
import Administración from '../pages/Administracion';
import DepartamentosResidentes from '../pages/DepartamentosResidentes';
import ResidentStatusPage from '../pages/ResidentStatusPage';
import ReporteMorosidadConfigurable from '../pages/ReporteMorosidadConfigurable';
import DepartamentosIdentificacion from '../pages/DepartamentosIdentificacion';
import DepartamentosMudanzas from '../pages/DepartamentosMudanzas';
import DepartamentosRFID from '../pages/DepartamentosRFID';
import Propietarios from '../pages/Propietarios';
import Arrendados from '../pages/Arrendados';
import GestionarCuentasVigilancia from '../pages/GestionarCuentasVigilancia';
import CobroSanciones from '../pages/CobroSanciones';
import ActivarConvenios from '../pages/ActivarConvenios';
import PropuestasIncidencias from '../pages/PropuestasIncidencias';
import CrearReporteComunidad from '../pages/CrearReporteComunidad';
import ListaComunicados from '../pages/ListaComunicados';
import VotacionesPage from '../pages/VotacionesPage';
import VotacionesAvisosResidente from '../pages/VotacionesAvisosResidente';
import EventosCitas from '../pages/EventosCitas';
import ChatComunitario from '../pages/ChatComunitario';
import ValidacionDocumentos from '../pages/ValidacionDocumentos';
import MudanzaConfig from '../pages/MudanzaConfig';
import HorariosAmenidades from '../pages/HorariosAmenidades';
import DatosContactoProveedores from '../pages/DatosContactoProveedores';
import RecibosEliminados from '../pages/RecibosEliminados';
import ListaIngresos from '../pages/ListaIngresos';
import ListaEgresos from '../pages/ListaEgresos';
import ConstanciaNoAdeudo from '../pages/ConstanciaNoAdeudo';
import GenerarReciboCobro from '../pages/GenerarReciboCobro';
import AvisoPrivacidad from '../pages/AvisoPrivacidad';
import ImportarDatos from '../pages/ImportarDatos';
import GestionSaldos from '../pages/Configuraciones/GestionSaldos';
import ConfiguracionFinanciera from '../pages/ConfiguracionFinanciera';

const UserRoutes = () => {
    const { userData } = useAuth();
    const role = String(userData?.rol || '').toLowerCase();
    const isAdmin = ['superadmin', 'admin', 'manager', 'plataforma', 'admin_fracc'].includes(role);

    return (
        <Routes>
            <Route element={<UserLayout />}>
                {/* Ruta por defecto: redirige a comunidad */}
                <Route index element={<Navigate to="comunidad" replace />} />
                <Route path="configuraciones" element={<Configuraciones />} />
                <Route path="configuraciones/faq" element={<PreguntasFrecuentes />} />
                <Route path="configuraciones/soporte" element={<Soporte />} />
                <Route path="configuraciones/perfil" element={<Perfil />} />
                <Route path="configuraciones/recibos" element={<ConfiguracionRecibos />} />
                <Route path="comunidad" element={<Comunidad />} />
                <Route path="comunidad/votaciones-avisos" element={
                    <RestriccionMorosidadGuard tabKey="comunidad" subKey="votaciones_avisos">
                        <VotacionesAvisosResidente />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/avisos" element={<Navigate to="/comunidad/votaciones-avisos" replace />} />
                <Route path="comunidad/comunicados/:categoria" element={<ListaComunicados />} />
                <Route path="comunidad/propuestas" element={
                    <RestriccionMorosidadGuard sectionKey="solicitudes" tabKey="comunidad" subKey="propuestas_incidencias">
                        <PropuestasIncidencias />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/propuestas/nueva" element={
                    <RestriccionMorosidadGuard sectionKey="solicitudes" tabKey="comunidad" subKey="propuestas_incidencias">
                        <CrearReporteComunidad />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/eventos" element={
                    <RestriccionMorosidadGuard tabKey="comunidad" subKey="eventos_citas">
                        <EventosCitas />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/eventos/agendar" element={
                    <RestriccionMorosidadGuard tabKey="comunidad" subKey="eventos_citas">
                        <EventosCitas />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/chat" element={
                    <ModuloGuard moduloKey="chat_comunitario">
                        <RestriccionMorosidadGuard sectionKey="chat" tabKey="comunidad" subKey="chat_comunitario">
                            <ChatComunitario />
                        </RestriccionMorosidadGuard>
                    </ModuloGuard>
                } />
                <Route path="comunidad/documentos" element={
                    <RestriccionMorosidadGuard sectionKey="solicitudes" tabKey="comunidad" subKey="solicitudes_permisos">
                        <ValidacionDocumentos />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="comunidad/contacto-proveedores" element={
                    <RestriccionMorosidadGuard sectionKey="datosContacto" tabKey="comunidad" subKey="directorio_contactos">
                        <DatosContactoProveedores />
                    </RestriccionMorosidadGuard>
                } />
                {isAdmin && (
                    <>
                        <Route path="configuraciones/mudanzas" element={<MudanzaConfig />} />
                        <Route path="configuraciones/amenidades-horarios" element={<HorariosAmenidades />} />
                        <Route path="configuraciones/importar" element={<ImportarDatos />} />
                        <Route path="configuraciones/saldos" element={<GestionSaldos />} />
                        <Route path="configuraciones/financiera" element={<ConfiguracionFinanciera />} />
                        <Route path="comunidad/votaciones" element={<VotacionesPage />} />
                    </>
                )}
                <Route path="amenidades" element={
                    <ModuloGuard moduloKey="amenidades">
                        <RestriccionMorosidadGuard sectionKey="amenidades" tabKey="amenidades">
                            <Amenidades />
                        </RestriccionMorosidadGuard>
                    </ModuloGuard>
                } />
                <Route path="vigilancia" element={
                    <RestriccionMorosidadGuard sectionKey="visitas" tabKey="vigilancia">
                        <Vigilancia />
                    </RestriccionMorosidadGuard>
                } />
                <Route path="finanzas" element={isAdmin ? <Finanzas /> : <FinanzasUsuario />} />
                <Route path="finanzas/ingresos" element={<ListaIngresos />} />
                <Route path="finanzas/egresos" element={<ListaEgresos />} />
                <Route path="finanzas/recibos-eliminados" element={<RecibosEliminados />} />
                {/* Rutas de Administración - Solo para administradores (superadmin, admin, etc.) */}
                {isAdmin && (
                    <>
                        <Route path="administracion" element={
                            <ModuloGuard moduloKey="administracion">
                                <Administración />
                            </ModuloGuard>
                        } />
                        <Route path="administracion/departamentos/residentes" element={<DepartamentosResidentes />} />
                        <Route path="administracion/departamentos/residentes/morosos/reporte" element={<ReporteMorosidadConfigurable />} />
                        <Route path="administracion/departamentos/residentes/:statusType" element={<ResidentStatusPage />} />
                        <Route path="administracion/departamentos/identificacion" element={<DepartamentosIdentificacion />} />
                        <Route path="administracion/departamentos/mudanzas" element={<DepartamentosMudanzas />} />
                        <Route path="administracion/departamentos/rfid" element={
                            <ModuloGuard moduloKey="desactivacion_rfid_morosos">
                                <DepartamentosRFID />
                            </ModuloGuard>
                        } />
                        <Route path="administracion/departamentos/vigilancia" element={<GestionarCuentasVigilancia />} />
                        <Route path="administracion/departamentos/constancia-no-adeudo" element={<ConstanciaNoAdeudo />} />
                        <Route path="administracion/recibo-cobro" element={<GenerarReciboCobro />} />
                        <Route path="administracion/cobro-sanciones" element={<CobroSanciones />} />
                        <Route path="administracion/convenios" element={<ActivarConvenios />} />
                    </>
                )}
                <Route path="admin/propietarios" element={<Propietarios />} />
                <Route path="admin/arrendados" element={<Arrendados />} />
                <Route path="aviso-privacidad" element={<AvisoPrivacidad />} />
            </Route>
        </Routes>
    );
};

export default UserRoutes;